import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/regulacao`

    const headers = {responseType: "arraybuffer"}

    return {
        solicitacaoRegulacao(id) {
            return repository.get(`${baseUrl}/solicitacao/${id}`, headers)
        },
        tentativaContato(id) {
            return repository.get(`${baseUrl}/tentativa-contato/${id}`, headers)
        },
        preparo(solicitacaoId) {
            return repository.get(`${baseUrl}/preparo/${solicitacaoId}`, headers)
        },
        historicoMovimentacaoSolicitacao(solicitacaoId) {
            return repository.get(`${baseUrl}/historico-movimentacao-solicitacao/${solicitacaoId}`, headers)
        },
    }
}